import React from 'react';
import EventCalendar from './EventCalendar';
import './Events.css';

function Events() {
  return (
    <section id="events">
      <div className="fade-in">
        
        {/* Hero Image Section */}
        <div className="events-image">
          <img src="/images/events.jpg" alt="Events" />
          <div className="hero-text">
            <h1 className="title">Upcoming Events</h1>
          </div>
        </div>

        {/* Calendar Display Section */}
        <div className="calendar-container">
          <EventCalendar />
        </div>
      </div>
    </section>
  );
}

export default Events;
